export default "__VITE_ASSET__C9_N7Kou__"